import { isNil } from "lodash";
export function validateEmail(email) {
  const pattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  return !pattern.test(String(email).toLowerCase());
}

export function uniqueArrObj(array, property) {
  return [...new Set(array.map(item => item[property]))].map(prop => array.find(item => item[property] === prop));
}

// transform [1,2,3,4,5,6,7...] to [[1,2,3], [4,5,6]...] if chunkSize=3 
export function transformArray(arr, chunkSize) {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
}

export function removeAccentsAndDiacritics(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function camelToSnakeCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toUpperCase();
}

export function compare<T = number | string>(a: T, b: T, isAsc: boolean) {
  if (a === b) return 0;
  if (isNil(a) || isNil(b)) return isNil(a) ? -1 : 1;
  if (typeof a === 'string' && typeof b === 'string') {
    return a.toLowerCase().localeCompare(b.toLowerCase(), undefined, { numeric: true, usage: "sort" }) * (isAsc ? 1 : -1);
  }
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function createEnumFromValues<T extends readonly string[]>(values: T) {
  return values.reduce((acc, val) => {
    acc[val as keyof typeof acc] = val;
    return acc;
  }, {} as { [K in T[number]]: K });
}
